"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromptProvider = void 0;
const react_1 = __importDefault(require("react"));
const prompt_hook_1 = require("./prompt-hook");
const prompt_context_1 = require("./prompt-context");
const prompt_dialog_1 = require("./prompt-dialog");
function PromptProvider({ PromptDialogComponent = prompt_dialog_1.PromptDialog, children, }) {
    const { context, dialogRef, prompt, promptConfirm, promptCancel, loading, } = prompt_hook_1.usePrompt();
    return (react_1.default.createElement(prompt_context_1.PromptContext.Provider, { value: context },
        children,
        react_1.default.createElement(PromptDialogComponent, { ref: dialogRef, prompt: prompt, onConfirm: promptConfirm, onCancel: promptCancel, loading: loading })));
}
exports.PromptProvider = PromptProvider;
//# sourceMappingURL=prompt-provider.js.map